import React, { useState } from "react";
import CategoriesTable from "./CategoriesTable";
import SubCategoriesTable from "./SubCategoriesTable";
import { ACCENT } from "../Places/PlacesTable";

const TABS = [
  { key: 0, label: "Catégories" },
  { key: 1, label: "Sous-catégories" },
] as const;

export default function ServiceCategories() {
  const [activeTab, setActiveTab] = useState<0 | 1>(0);

  return (
    <section>
      <h5 className="fs-4 fw-bold mb-3">Catégories de services</h5>

      <div className="d-flex gap-2 mb-3">
        {TABS.map((tab) => {
          const active = activeTab === tab.key;
          return (
            <button
              key={tab.key}
              type="button"
              onClick={() => setActiveTab(tab.key)}
              className="border-0 rounded-pill"
              style={{
                padding: "8px 18px",
                fontSize: 14,
                fontWeight: 600,
                color: active ? "#fff" : "#444",
                backgroundColor: active ? ACCENT : "#fff",
                boxShadow: active
                  ? "0 4px 12px rgba(240,129,63,0.35)"
                  : "0 1px 3px rgba(0,0,0,0.08)",
                transition: "all .15s ease",
              }}
            >
              {tab.label}
            </button>
          );
        })}
      </div>

      {activeTab === 0 && <CategoriesTable />}
      {activeTab === 1 && <SubCategoriesTable />}
    </section>
  );
}
